import { render } from "./AlphaGoat01S2.vue?vue&type=template&id=8cf6a0b4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__